import * as echarts from 'echarts';
import store from '@/store/index';
export function createChart(id,obj){
    var data=[
        { value: 0, name: '优秀',itemStyle:{color:'#0067FF'} },
        { value: 0, name: '达标',itemStyle:{color:'#5B9DFF'}  },
        { value: 0, name: '不达标',itemStyle:{color:'#A5C9FF'}  },
    ];
    data.forEach(item=>{
        item.value=obj[item.name]
    });
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;

    option = {
    tooltip: {
        trigger: 'item'
    },
    legend: {
        itemHeight: 15,
        itemWidth: 15,
        top: '5%',
        left: 'left',
        orient:'vertical',
        itemGap:25,
        textStyle: {
            color: '#151C34'  // 改变图例文字颜色为红色
        }
    },
    series: [
        {
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        label: {
            show: false,
            position: 'center'
        },
        emphasis: {
            label: {
            show: true,
            fontSize: 10,
            fontWeight: 'bold'
            }
        },
        labelLine: {
            show: false
        },
        center: ['80%', '50%'],
        data:data
        }
    ]
    };

    option && myChart.setOption(option);
    return myChart;
}
/**课程数据折线图 */
export function foldChart(id,title='',data={},xData){
    var chartDom = document.getElementById(id);
    var myChart = echarts.init(chartDom);
    var option;
    var series=[];
    for(let key in data){
        var obj={
            name:data[key].label,
            type: 'line',
            smooth:true,
            data:data[key].data||[0, 0, 0, 0, 0, 0, 0],
            symbolSize: 8 // 点的大小
        };
        series.push(obj);
    }
    option = {
    color:['#387DFF','#EAD656','#FE7C4B','#23B899'],
    title: {
        text: title
    },
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        orient:'horizontal',
        top: '10%',
        left: 'right',
        itemGap:10
    },
    grid: {
        top:'30%',
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        boundaryGap: false,
        data:xData||['一周', '两周', '三周', '四周', '五周', '六周', '七周'],
        splitLine: { // 设置 x 轴网格线
            show: true, // 是否显示网格线
            lineStyle: { // 网格线的样式
                color: '#EAEBF0', // 颜色
            }
        },
        axisLine: {
            lineStyle: {
                color: '#EAEBF0' // 修改为红色
            }
        },
        axisLabel: {
            textStyle: {
                color: '#6C7293' // 修改为红色
            }
        },
        axisTick: {
            show: false // 隐藏 x 轴刻度线
        }
    },
    yAxis: {
        type: 'value',
        name: '单位：分钟',  // 单位显示在轴标题
        nameLocation: 'end',  // 标题位置（默认end/start）
        nameTextStyle: {
            color: '#666',
            fontSize: 14,
            padding: [0, 0, 0, 0]  // 调整标题与图表间距
        },
        splitLine: { // 设置 x 轴网格线
            show: true, // 是否显示网格线
            lineStyle: { // 网格线的样式
                color: '#EAEBF0', // 颜色
            }
        },
        axisLine: {
            lineStyle: {
                color: '#EAEBF0' // 修改为红色
            }
        },
        axisLabel: {
            textStyle: {
                color: '#6C7293' // 修改为红色
            }
        },
        axisTick: {
            show: false // 隐藏 x 轴刻度线
        }
    },
    series
    };
    let mapping={
        mobile:{
            legend: {
                orient:'horizontal',
                top: '10%',
                left: '50%',
                itemGap:10
            },
            grid: {
                top:'40%',
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
        },
        pc:{
            legend: {
                orient:'horizontal',
                left: 'right',
                itemGap:35
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',
                containLabel: true
            },
        }
    }
    option.legend=mapping[store.state.media.showSlider?'mobile':'pc'].legend;
    option.grid=mapping[store.state.media.showSlider?'mobile':'pc'].grid;
    console.log(store.state.showSlider,option.legend,'ooo')
    option && myChart.setOption(option);
    return  myChart;
}